import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface PartnerPayments {
  payments: Array<{
    createdAt: string;
    amount: number;
  }>;
  count: number;
}

export default (makeCall: MakeCall) => (
  partnerId: number,
  fromDate: string,
  toDate: string,
) =>
  makeCall<PartnerPayments>('GET', `/api/v2/partner/${partnerId}/payments`, {
    query: {
      fromDate,
      toDate,
    },
  });
